module.exports = __webpack_public_path__ + "static/media/masala.eb9571da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/masala.jpg
// module id = 208
// module chunks = 0